<template>
    <div class="flex h-screen">
        <Left />
        <KnowledgeBase />
        <Right />
    </div>
</template>

<script>
import Left from './Left.vue'
import Right from './Right.vue'
import KnowledgeBase from './KnowledgeBase.vue'

export default {
    name: 'KnowledgeBaseLayout',
    components: {
        Left,
        Right,
        KnowledgeBase
    }
}
</script>
